/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { useMutation } from '@tanstack/react-query'
import type { UseMutationOptions } from '@tanstack/react-query'
import type { AxiosError, AxiosRequestConfig } from 'axios'
import { hubSpotLinkDestroy } from '../../axios/hubSpotLinkDestroy'
import type {
	HubSpotLinkDestroyError,
	HubSpotLinkDestroyPathParams,
	HubSpotLinkDestroyResponse,
} from '../../types/HubSpotLinkDestroy'

export const hubSpotLinkDestroyMutationKey = () => [{ url: '/:organisation/hubspot' }] as const

export type HubSpotLinkDestroyMutationKey = ReturnType<typeof hubSpotLinkDestroyMutationKey>

export type HubSpotLinkDestroyVariables = {
	organisation: HubSpotLinkDestroyPathParams['organisation']
}

/** @see backend/nexus/modules/SupplyChain/Http/Controllers/HubSpotLinkController.php HubSpotLinkController::destroy */
export function useHubSpotLinkDestroy<TContext = unknown>(
	options?: UseMutationOptions<
		HubSpotLinkDestroyResponse,
		AxiosError<HubSpotLinkDestroyError>,
		HubSpotLinkDestroyVariables,
		TContext
	>,
	config?: AxiosRequestConfig,
) {
	return useMutation({
		mutationKey: hubSpotLinkDestroyMutationKey(),
		mutationFn: ({ organisation }: HubSpotLinkDestroyVariables) =>
			hubSpotLinkDestroy(organisation, config).then(res => res.data),
		...options,
	})
}
